export enum FileUploadStatus {
    Uploading = 'uploading',
    Failed = 'failed',
    Completed = 'completed',
  }
  